// import { ChevrondownSvg } from "@/src/Asset";
import React, { ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';

interface AccordionProps {
  children: ReactNode;
  title: string;
  titleTag?: any;
  titlePrimary?: boolean;
  isBgColor?: boolean;
  bgColorBody?: string;
  opened: boolean;
  onToggle: () => void;
}

const Accordion: React.FC<AccordionProps> = ({
  children,
  title,
  titleTag = 'p', // default fallback
  titlePrimary = false,
  isBgColor = false,
  bgColorBody = 'bg-gray-50',
  opened,
  onToggle,
}) => {
  const TitleTag = titleTag;

  return (
    <div className="rounded-md">
      <button
        className={`flex justify-between items-center text-start p-2 cursor-pointer w-full ${
          !opened ? 'border-b' : ''
        } ${isBgColor ? 'bg-orange-100' : 'bg-primary-light'}`}
        onClick={onToggle}
      >
        <TitleTag
          className={`flex-1 ${
            titlePrimary ? 'text-primary text-base md:text-xl font-semibold' : 'text-primary text-base'
          }`}
        >
          {title}
        </TitleTag>
        <ChevronDown className={`text-gray-600 duration-200 sm:text-lg ${!opened ? '' : '-rotate-90'}`} />
      </button>
      {!opened && <div className={`p-2 md:p-3 ${bgColorBody} transition-all duration-300`}>{children}</div>}
    </div>
  );
};

export default Accordion;
